<template>
    <v-content class="PageLoginLayout">

        <div class="initialView">
            <div class="initialViewContent">
                <router-view></router-view>
            </div>
        </div>

    </v-content>
</template>

<script>
    import {
        mdiAccount,
        mdiAccountKey,
    } from '@mdi/js';
    export default {
        name: "PageLogin",
        data: () => ({
            mdiAccount: mdiAccount,
            mdiAccountKey: mdiAccountKey,
		}),
		created(){
			if(!this.$route.path.startsWith("/login")){
				this.$router.replace("/login")
			} 
		}
    }
</script>

<style lang="less">
    .PageLoginLayout {
        .initialView {
            width: 450px;
            border: 1px solid #dadce0;
            border-radius: 8px;
            display: block;
            margin: 0 auto;
            margin-top: 44px;
            background: #fff;
            max-width: 100%;

            .initialViewContent {
                padding: 30px 40px 36px 40px;
            }
        }
    }
</style>